import { useEffect } from 'react';

const useSocketListener = (socket, user, eventName, callback, dependencies = []) => {
  useEffect(() => {
    if (!user?.companyId || !socket || typeof socket.on !== 'function') {
      console.warn('useSocketListener: Condições não atendidas:', {
        hasUser: !!user,
        hasCompanyId: !!user?.companyId,
        hasSocket: !!socket,
        hasOnMethod: socket && typeof socket.on === 'function'
      });
      return;
    }

    const fullEventName = `company-${user.companyId}-${eventName}`;
    
    try {
      console.log(`Registrando listener: ${fullEventName}`);
      const success = socket.on(fullEventName, callback);
      
      if (success === false) {
        console.error(`Falha ao registrar listener: ${fullEventName}`);
        return;
      }

      return () => {
        if (socket && typeof socket.off === 'function') {
          console.log(`Removendo listener: ${fullEventName}`);
          socket.off(fullEventName, callback);
        }
      };
    } catch (error) {
      console.error(`Erro ao configurar listener ${fullEventName}:`, error);
    }
  }, [socket, user?.companyId, eventName, callback, ...dependencies]);
};

export default useSocketListener;